export default __webpack_public_path__ + "static/media/register_4.c97aa214.jpg";